import React from "react";
import { createRoot } from "react-dom/client";
import * as serviceWorker from "./serviceWorker";

import App from "./App";
import { AppProvider } from "./context/store";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import { Provider } from "react-redux";
import { store } from "./redux/store";

if (process.env.NODE_ENV === "production") {
  disableReactDevTools();
}
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <AppProvider>
      <App />
    </AppProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
